import { Dices, Flame, Trophy, Zap } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

const categories = [
  {
    icon: Trophy,
    title: "Esportes",
    description: "As melhores odds em futebol, basquete e muito mais",
    color: "from-blue-500 to-purple-600",
    path: "/sports",
  },
  {
    icon: Dices,
    title: "Cassino",
    description: "Milhares de slots e jogos de mesa clássicos",
    color: "from-purple-500 to-pink-600",
    path: "/casino",
  },
  {
    icon: Flame,
    title: "Cassino ao Vivo",
    description: "Dealers reais, emoção em tempo real",
    color: "from-orange-500 to-red-600",
    path: "/live-casino",
  },
  {
    icon: Zap,
    title: "Jogos Rápidos",
    description: "Crash, Aviator e mais jogos instantâneos",
    color: "from-yellow-500 to-orange-600",
    path: "/crash-games",
  },
];

const GameCategories = () => {
  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Escolha Sua Categoria
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Explore nossas categorias e encontre a experiência perfeita para você
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category, index) => (
            <Link to={category.path} key={index}>
              <Card
                className="group relative overflow-hidden border-border hover:border-primary/50 transition-all duration-300 hover:shadow-glow cursor-pointer animate-fade-in h-full"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CardContent className="p-6">
                  <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${category.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <category.icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
                    {category.title}
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    {category.description}
                  </p>
                </CardContent>
                <div className="absolute inset-0 bg-gradient-to-br from-primary/0 to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GameCategories;